/*
 * Keep-shopping link for the cart drawer.
 *
 * After add-to-cart, Dawn re-renders the drawer via the Section Rendering API,
 * which drops the Liquid `collection` context. So we derive the collection the
 * shopper is browsing from the page URL (captured on load) and keep the drawer's
 * "Keep shopping" link pointed at it across every re-render. If there is no
 * collection in the path (e.g. the drawer was opened from the homepage), the link
 * stays hidden so we never show a dead "back to the range" link.
 */
(function () {
  function collectionUrlFromPath() {
    var path = window.location.pathname;
    var marker = '/collections/';
    var i = path.indexOf(marker);
    if (i === -1) return null;
    // Next path segment after /collections/ is the collection handle. This works
    // for both /collections/<handle> and /collections/<handle>/products/<x>, and
    // preserves any locale prefix that sits before /collections/.
    var handle = path.slice(i + marker.length).split('/')[0];
    if (!handle) return null;
    return path.slice(0, i) + marker + handle;
  }

  var url = collectionUrlFromPath();

  function sync() {
    var links = document.querySelectorAll('.cart-keep-shopping');
    for (var n = 0; n < links.length; n++) {
      if (url) {
        links[n].setAttribute('href', url);
        links[n].hidden = false;
      } else {
        links[n].hidden = true;
      }
    }
  }

  function init() {
    sync();
    // The <cart-drawer> element persists; only its inner HTML is swapped on
    // re-render. Watching childList/subtree (not attributes) re-syncs the link
    // after each swap without looping on our own href/hidden writes.
    var drawer = document.querySelector('cart-drawer');
    if (drawer && 'MutationObserver' in window) {
      new MutationObserver(sync).observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
